import { UserShortModel } from 'services/user.model';

export const getUsersWithoutAssigned = (users: UserShortModel[], assignedIds: string[]) => {
  return users?.filter((user) => !assignedIds.includes(user.id)) || [];
};
